import { PageBarTab }   from 'src/app/services/page-bar.service';
import { SiteFeatures } from 'src/app/bo/siteFeatures';

export type BlastTabMode = 'new' | 'legacy';

export interface BlastTab extends PageBarTab {
  mode:     BlastTabMode;
  feature?: keyof SiteFeatures;
}

export const BLAST_TABS: BlastTab[] = [
  { id: 'dashboard',         label: 'GLOBAL.GENERAL',               dataAttr: 'site-tab-blast-dashboard',         mode: 'new'    },
  { id: 'files',             label: 'GLOBAL.FICHIERS',                   dataAttr: 'site-tab-blast-files',             mode: 'new'    },
  { id: 'history',           label: 'BLAST_HISTORY.HISTORY',                 dataAttr: 'site-tab-blast-history',           mode: 'new'    },
  { id: 'kpi',               label: 'GLOBAL.DONNEES_ANALYSE',                     dataAttr: 'site-tab-blast-kpi',               mode: 'new'    },
  { id: 'holes',             label: 'GLOBAL.TROUS',                   dataAttr: 'site-tab-blast-holes',             mode: 'new'    },
  { id: 'vibrations',        label: 'GLOBAL.VIBRATIONS',              dataAttr: 'site-tab-blast-vibration',         mode: 'new',    feature: 'showVibrationsTab'            },
  { id: 'fragmentation',     label: 'GLOBAL.FRAGMENTATION',           dataAttr: 'site-tab-blast-fragmentation',     mode: 'new',    feature: 'showFragmentationTab'         },
  { id: 'load-haul',         label: 'FEATURES.LOAD_AND_HAUL',             dataAttr: 'site-tab-blast-load-haul',         mode: 'legacy', feature: 'showLoadAndHaulTab'           },
  { id: 'fleet',             label: 'FEATURES.FLEET_MANAGEMENT', dataAttr: 'site-tab-blast-fleet',             mode: 'legacy', feature: 'showFleetManagementSystemTab' },
  { id: 'feedback',          label: 'GLOBAL.CUSTOMER_FEEDBACK',                dataAttr: 'site-tab-blast-feedback',          mode: 'new'    },
  { id: 'supplier-feedback', label: 'GLOBAL.SUPPLIYER_FEEDBACK',       dataAttr: 'site-tab-blast-supplier-feedback', mode: 'new'    },
  { id: 'environment',       label: 'GLOBAL.ENVIRONMENT',             dataAttr: 'site-tab-blast-environment',       mode: 'new',    feature: 'showEnvironmentTab'           },
];

const DEFAULT_SITE_FEATURES = new SiteFeatures();

export function isLegacyBlastTab(id: string): boolean {
  return BLAST_TABS.some(tab => tab.id === id && tab.mode === 'legacy');
}

export function isBlastTabEnabled(tab: BlastTab, features: SiteFeatures | null | undefined): boolean {
  if (!tab.feature) return true;
  return features?.[tab.feature] ?? DEFAULT_SITE_FEATURES[tab.feature];
}
